// extracted by mini-css-extract-plugin
export default {"skeletonCard":"SkeletonCard_skeletonCard__IgM1U","skeletonImage":"SkeletonCard_skeletonImage__q1WIG","skeletonInfo":"SkeletonCard_skeletonInfo__2L4re"};